import SearchField from '../SearchField'
import useViaSpecific from './hooks/useViaSpecific'

import { Wrapper, ContentWrapper, SearchBox, Controller, InlineHeaderWrap } from './Styled'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSearchHistory } from 'hooks/useSearchHistory'
import Tabs from 'component/Tabs'
import { TabsType } from 'component/Tabs/Styled'
import { usePageActivated } from 'app-layered-layout/usePageActivated'
import { useContentTab } from 'hooks/useContentTab'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SearchTab, type SearchMode } from './component/SearchTab'

const INACTIVE_STATE = {
  hasMore: false,
  isLoading: false,
  isPlaceHolder: true,
  list: [],
}

/**
 *
 * @param {number[]} searchTypes
 * @returns
 */
export default function ViaSpecific() {
  const { tabs } = useContentTab()

  const { state, searchTitle, onSearch, onCancel, handleFetchVideoList, onHistoryClick, mode, onChangeMode } =
    useViaSpecific()

  const [text, setText] = useState(searchTitle ?? '')

  const pageActivated = usePageActivated()

  useEffect(() => {
    if (pageActivated) {
      setText(searchTitle ?? '')
    }
  }, [pageActivated, searchTitle])

  const { add } = useSearchHistory()

  const onSearchWithHistory = useCallback(
    (word: string) => {
      if (!word) {
        return
      }

      add(mode, word)
      return onSearch(word)
    },
    [add, mode, onSearch]
  )

  const onChangeModeWithHistory = useCallback(
    (mode: string) => {
      if (searchTitle) {
        add(mode, searchTitle)
      }
      onChangeMode(mode)
    },
    [add, onChangeMode, searchTitle]
  )

  const onRemoveContent = () => {
    // cancel the search if we are doing search
    if (searchTitle) {
      return onCancel()
    }

    // only clear if we are not searching
    setText('')
  }

  const shortInfo = useMemo(() => {
    if (mode !== 'short') {
      return {
        list: [],
      }
    } else {
      return {
        list: state.list,
      }
    }
  }, [mode, state.list])

  const tabContentRef = useRef<any>()

  const onClickTab = useCallback(
    (mode: string) => {
      const newIndex = tabs.findIndex((t) => t.id === mode)
      tabContentRef.current?.swiper.slideTo(newIndex)
    },
    [tabs]
  )

  const onSlideChange = useCallback(
    (swiper: any) => {
      if (tabs[swiper.activeIndex].id !== mode) {
        console.log(tabs[swiper.activeIndex].id)
        onChangeModeWithHistory(tabs[swiper.activeIndex].id)
      }
    },
    [mode, onChangeModeWithHistory, tabs]
  )

  const initialSlide = useRef(tabs.findIndex((i) => i.id === mode))

  return (
    <Wrapper>
      <ContentWrapper>
        <InlineHeaderWrap>
          <Controller>
            <SearchBox>
              <SearchField
                placeholder={'输入关键字搜寻'}
                value={text}
                onChange={setText}
                onSearch={onSearchWithHistory}
                onRemoveContent={onRemoveContent}
              />
            </SearchBox>
          </Controller>
          {tabs.length > 1 && <Tabs type={TabsType.Underline} options={tabs} value={mode} onChange={onClickTab} />}
        </InlineHeaderWrap>

        <Swiper
          ref={tabContentRef}
          spaceBetween={10}
          onSlideChange={onSlideChange}
          initialSlide={initialSlide.current}
          style={{ width: '100%', flex: '1 1 auto', minHeight: '0px' }}
          cssMode
        >
          {tabs.map((t) => (
            <SwiperSlide key={t.id}>
              <SearchTab
                mode={t.id as SearchMode}
                searchTitle={searchTitle}
                state={mode === t.id ? state : INACTIVE_STATE}
                handleFetchVideoList={handleFetchVideoList}
                shortInfo={shortInfo}
                onHistoryClick={onHistoryClick}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </ContentWrapper>
    </Wrapper>
  )
}
